import React from "react";
import assets from "../../assets";
import "./style.sass";
import useHandler from "./handler";
import { useSingleton } from "../../hooks/use-singleton";
import { useNavigate } from "react-router-dom";

export const TeacherDashboard = () => {
  const { statsCards, pathCards } = useHandler();
  const { user } = useSingleton();
  const navigate = useNavigate();
  const currentDate = new Date().getDate();
  const currentMonth = new Date().toLocaleString("en-US", {
    month: "short",
  });
  const currentYear = new Date().getFullYear();

  const renderStatCard = (card, index) => (
    <div key={index} className="stat_card">
      <div
        className="stat_icon_wrapper"
        style={{ backgroundColor: card.iconBg }}
      >
        <img src={card.icon} alt={card.title} />
      </div>
      <div className="stat_info">
        <span className="stat_label">{card.title}</span>
        <span className="stat_value">{card.value}</span>
      </div>
    </div>
  );

  const renderPathCard = (path, index) => (
    <div key={index} className="path_card">
      <div className="path_icon_bg" style={{ backgroundColor: path.bgColor }}>
        <img src={path.icon} alt={path.title} />
      </div>
      <h3>{path.title}</h3>
      <p>{path.description}</p>
      <a className="path_action" onClick={() => navigate(path.route)}>
        {path.action} <img src={assets.ic_arrow_blue} alt="arrow" />
      </a>
    </div>
  );

  return (
    <>
      <header className="teacher_header">
        <div className="header_left">
          <h1>Welcome back, {user?.data?.name} 👋</h1>
          <p>Here's what's happening in your classes today.</p>
        </div>
        <div className="header_right">
          <div className="date_picker">
            <img src={assets.ic_calendar} alt="calendar" />
            <span>{`${currentDate} -${currentMonth}  -${currentYear}`}</span>
          </div>
          {/* <div className="notification_icon">
            <img src={assets.ic_notify_active} alt="notification" />
          </div> */}
          <div className="profile_brief">
            <div className="avatar">{user?.data?.name?.[0]?.toUpperCase()}</div>
            <div className="profile_info">
              <span className="name">{user?.data?.name}</span>
              <span className="role">{user?.data?.subject}</span>
            </div>
          </div>
        </div>
      </header>

      <div className="teacher_dashboard_content">
        <div className="stats_grid">{statsCards?.map(renderStatCard)}</div>

        <h2 className="section_title">Today's Path</h2>

        <div className="path_grid">{pathCards?.map(renderPathCard)}</div>
      </div>
    </>
  );
};
